import { alertController } from '@ionic/core/components';
import { html } from '../lib/html.js';
import { toastError, toastSuccess } from '../lib/ui.js';
import { ago, reviews } from '../services/reviews.js';
import { fmtRating } from '../services/showcase.js';

/** Pedaços de tela das avaliações (perfil público, lista completa e a tela da oficina). */

export const stars = (n, size = '') => html`<span class="stars ${size}" aria-label="Nota ${n} de 5">${[1, 2, 3, 4, 5].map((i) => html`<ion-icon name="${i <= n ? 'star' : 'star-outline'}" aria-hidden="true"></ion-icon>`)}</span>`;

/** Resumo: nota grande, total e barras de 1 a 5, e as etiquetas mais citadas. */
export function summaryBlock(s) {
  if (!s?.count) return '';
  const max = Math.max(...s.dist, 1);
  return html`
    <div class="panel rv-summary">
      <div class="rv-avg">
        <b>${fmtRating(s.avg)}</b>
        ${stars(Math.round(s.avg), 'sm')}
        <span>${s.count} ${s.count === 1 ? 'nota' : 'notas'}</span>
      </div>
      <div class="rv-bars">
        ${[5, 4, 3, 2, 1].map((n) => html`<div class="rv-bar"><span>${n}</span><i><b style="width:${Math.round((s.dist[n - 1] / max) * 100)}%"></b></i></div>`)}
      </div>
    </div>
    ${s.topTags?.length ? html`<div class="tags wrap rv-top">${s.topTags.map((t) => html`<span class="tag ${t.positive ? 'good' : 'bad'}">${t.label} · ${t.count}</span>`)}</div>` : ''}`;
}

/** Uma avaliação: autor, carro · serviço · quando, nota, etiquetas, texto, selo de serviço registrado e a resposta. */
export function reviewCard(r, { reportable = false, replyable = false } = {}) {
  return html`
    <article class="panel rv-card">
      <div class="rv-head">
        <span class="rv-avatar" aria-hidden="true">${(r.author ?? '?').charAt(0)}</span>
        <div class="row-main">
          <span class="row-title">${r.author}</span>
          <span class="row-sub">${[r.vehicle, r.service, ago(r.createdAt)].filter(Boolean).join(' · ')}</span>
        </div>
        ${stars(r.rating, 'sm')}
      </div>
      ${r.tags?.length ? html`<div class="tags wrap">${r.tags.map((t) => html`<span class="tag">${t}</span>`)}</div>` : ''}
      ${r.comment ? html`<p class="rv-text">${r.comment}</p>` : ''}
      <span class="rv-verified"><ion-icon name="checkmark-circle-outline" aria-hidden="true"></ion-icon>Serviço registrado no TicketCar${r.edited ? ' · editada' : ''}</span>
      ${r.reply ? html`<div class="rv-reply"><strong>Resposta da empresa</strong><p>${r.reply.text}</p></div>` : ''}
      ${replyable && !r.reply ? html`<ion-button size="small" fill="outline" data-action="reply" data-id="${r.id}">Responder</ion-button>` : ''}
      ${reportable ? html`<button type="button" class="link-btn rv-report" data-action="report" data-id="${r.id}" data-reply="${r.reply ? '1' : ''}">Denunciar</button>` : ''}
    </article>`;
}

/** Denunciar avaliação (ou a resposta da oficina): motivo e envio. */
export async function reportReview(id, hasReply) {
  const inputs = [
    { type: 'radio', label: 'Ofensa ou linguagem imprópria', value: 'REVIEW:OFFENSIVE', checked: true },
    { type: 'radio', label: 'Expõe dados pessoais', value: 'REVIEW:PERSONAL_DATA' },
    { type: 'radio', label: 'Não parece um cliente de verdade', value: 'REVIEW:FAKE' },
    ...(hasReply ? [{ type: 'radio', label: 'A resposta da empresa é imprópria', value: 'REPLY:OFFENSIVE' }] : []),
  ];
  const a = await alertController.create({ header: 'Denunciar', message: 'A equipe do TicketCar analisa e pode ocultar.', inputs, buttons: [{ text: 'Cancelar', role: 'cancel' }, { text: 'Enviar', role: 'confirm' }] });
  await a.present();
  const { role, data } = await a.onDidDismiss();
  if (role !== 'confirm' || !data?.values) return;
  const [target, reason] = String(data.values).split(':');
  try {
    await reviews.report(id, { target, reason });
    toastSuccess('Denúncia enviada. Obrigado por avisar.');
  } catch (e) {
    toastError(e.message);
  }
}
